(() => {
  const SELECTOR = '[data-circle-category-slider]';

  const debounce = (fn, wait = 120) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  };

  const getTotalPages = (carousel, slides) => {
    if (!slides.length) return 1;

    const grid = carousel.querySelector('.slider__grid');
    if (!grid || slides.length < 2) return 1;

    const slideSpan = slides[1].offsetLeft - slides[0].offsetLeft;
    if (!slideSpan) return 1;

    const slideGap = slideSpan - slides[0].clientWidth;
    const gridWidth = grid.clientWidth;
    const slidesPerPage = Math.max(1, Math.round((gridWidth + slideGap) / slideSpan));
    return Math.max(1, slides.length - slidesPerPage + 1);
  };

  const buildDots = (carousel, slides) => {
    const dotsWrap = carousel.querySelector('[data-circle-category-dots]');
    if (!dotsWrap) return [];

    const totalPages = getTotalPages(carousel, slides);
    dotsWrap.innerHTML = '';

    if (totalPages < 2) {
      dotsWrap.hidden = true;
      return [];
    }

    dotsWrap.hidden = false;
    const dots = [];

    for (let i = 0; i < totalPages; i += 1) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'mcbs__dot';
      dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
      dot.dataset.index = String(i);
      dot.addEventListener('click', () => {
        if (typeof carousel.scrollToElement === 'function' && slides[i]) {
          carousel.scrollToElement(slides[i]);
        }
      });
      dotsWrap.append(dot);
      dots.push(dot);
    }

    return dots;
  };

  const getCurrentPageIndex = (carousel, slides, dots) => {
    if (!slides.length || !dots.length) return -1;
    const slider = carousel.querySelector('.slider');
    if (!slider || slides.length < 2) return 0;

    const slideSpan = slides[1].offsetLeft - slides[0].offsetLeft;
    if (!slideSpan) return 0;

    const slideIndex = Math.round(Math.abs(slider.scrollLeft) / slideSpan);
    return Math.max(0, Math.min(slideIndex, dots.length - 1));
  };

  const setActiveDot = (dots, index) => {
    dots.forEach((dot, dotIndex) => {
      dot.classList.toggle('mcbs__dot--active', dotIndex === index);
    });
  };

  const initCarousel = (carousel) => {
    if (!carousel || carousel.dataset.circleCategoryReady === 'true') return;

    const slides = [...carousel.querySelectorAll('.slider__item')];
    if (!slides.length) return;

    const setup = () => {
      const dots = buildDots(carousel, slides);
      if (!dots.length) return dots;

      const activeIndex = getCurrentPageIndex(carousel, slides, dots);
      setActiveDot(dots, activeIndex);

      dots.forEach((dot, dotIndex) => {
        dot.addEventListener('click', () => {
          setActiveDot(dots, dotIndex);
        });
      });

      return dots;
    };

    let dots = setup();

    carousel.addEventListener('on:carousel-slider:select', (event) => {
      if (!dots.length) return;
      const slideIndex = Number(event?.detail?.index || 0);
      const dotIndex = Math.max(0, Math.min(slideIndex, dots.length - 1));
      setActiveDot(dots, dotIndex);
    });

    const handleResize = debounce(() => {
      dots = setup();
    }, 150);

    window.addEventListener('on:debounced-resize', handleResize);
    carousel.dataset.circleCategoryReady = 'true';
  };

  const init = (root = document) => {
    root.querySelectorAll(SELECTOR).forEach(initCarousel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
